<ng-template>
    <div class="column-wrapper">
        <span (click)="sortColumn()" [class.sortable]="sortable"><ng-content></ng-content></span>
        <mpro-atable-sort-arrows (click)="sortColumn()" *ngIf="sortable" [active]="(columnService.sortObs | async)?.column === sortable" [direction]="(columnService.sortObs | async)?.direction || this.direction"></mpro-atable-sort-arrows>
    </div>
</ng-template>